import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ProductPagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  return (
    <nav className="flex items-center justify-center gap-2" aria-label="Product pagination">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="inline-flex size-10 items-center justify-center rounded-full border border-border disabled:opacity-40"
      >
        <ChevronLeft className="size-4" />
      </button>

      <div className="hidden gap-2 sm:flex">
        {Array.from({ length: totalPages }).map((_, index) => {
          const current = index + 1;

          return (
            <button
              key={current}
              type="button"
              onClick={() => onChange(current)}
              aria-current={page === current ? "page" : undefined}
              className={`size-10 rounded-full border text-sm ${
                page === current
                  ? "border-foreground bg-foreground text-background"
                  : "border-border bg-white"
              }`}
            >
              {current}
            </button>
          );
        })}
      </div>

      <span className="px-3 text-sm text-muted-foreground sm:hidden">
        {page} / {totalPages}
      </span>

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="inline-flex size-10 items-center justify-center rounded-full border border-border disabled:opacity-40"
      >
        <ChevronRight className="size-4" />
      </button>
    </nav>
  );
}